module.exports = __webpack_public_path__ + "img/outpatientIncomeSecond.613d3c41.svg";